import { FormInstance } from 'antd';
import { NamePath } from 'antd/es/form/interface';
import dayjs from 'dayjs';
import { IntlShape } from 'react-intl';

export const months = Array.from({ length: 12 }, (_, index) => index + 1);
export const days = Array.from({ length: 31 }, (_, index) => index + 1);
export const checkDateWithinDays = (date: string | string[], form: FormInstance, name: NamePath, intl: IntlShape) => {
  const currentDate = dayjs();
  const futureDate = currentDate.add(105, 'day');
  let isValid = true;
  const checkSingleDate = (date: string) => {
    const selectedDayjsDate = dayjs(date);
    if (selectedDayjsDate.isBefore(futureDate)) {
      form.setFields([
        {
          name: [name],
          errors: [intl.formatMessage({ id: 'validate.errorSelectShipmentDate' })],
        },
      ]);
      isValid = false;
    } else {
      isValid = true;
      form.setFields([{ name: [name], errors: undefined }]);
    }
  };

  if (Array.isArray(date)) {
    date.forEach((d) => checkSingleDate(d));
  } else {
    checkSingleDate(date);
  }
  return isValid;
};

/**
 * Helper function automatically import all JSON files in the locale directory
 * Using webpack's require.context to automatically map the files
 * @param context - The directory path containing the JSON files
 * Example: const context = (require as any).context(`./`, false, /\.json$/);
 * @returns Object containing all messages from the merged JSON files
 */
export const importAllJsonFiles = (context: any): Record<string, any> => {
  // require.context is a webpack feature to automatically import files
  // Using type assertion because require.context is not in the NodeRequire type by default
  const messages: Record<string, any> = {};

  // Get the list of all JSON files
  const fileNames = context.keys();

  // Import and merge all JSON files
  fileNames.forEach((fileName: string) => {
    const module = context(fileName);
    // Merge all keys from the JSON file into messages
    Object.assign(messages, module.default || module);
  });
  console.log({ context, messages, fileNames });
  return messages;
};
